import { render, staticRenderFns } from "./CreateCampaignSuccessPage.vue?vue&type=template&id=21c6c0b0"
import script from "./CreateCampaignSuccessPage.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports